import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import { BrandModel } from '../models/BrandModel';
import { ProductModel } from '../models/ProductModel';
import { RootModel } from '../models/RootModel';
import { ItemModel } from '../models/ItemModel';
import { DetailModel } from '../models/DetailModel';
import { PriceNoticeModel } from '../models/PriceNoticeModel';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    private path = '/';
    private dbPath = 'pipe';
    private dbPath1 = 'brand';
    private dbPath2 = 'products';
    private dbPath3 = 'items';
    private dbpath4 = 'pricenotice';
    private dbPath5 = 'linkprice';

    constructor(private db: AngularFireDatabase) {
    }

    //get list preice notice
    getListPriceNotice(): AngularFireList<PriceNoticeModel> {
        return this.db.list(this.dbpath4);
    }

    getListPriceNoticeDetail(id: String): AngularFireList<PriceNoticeModel> {
        return this.db.list(this.dbpath4 + this.path + id + this.path + this.dbPath5);
    }

    //get list menu navigation bar
    getListMenuBar(): AngularFireList<RootModel> {
        return this.db.list(this.dbPath);
    }

    getListSubMenu(id: String): AngularFireList<BrandModel> {
        return this.db.list(this.dbPath + this.path + id + this.path + this.dbPath1);
    }

    //get detail product and list price of items
    getDetailProduct(id1: string, id2: string, id3: String): AngularFireObject<DetailModel> {
        return this.db.object(this.dbPath + this.path + id1 + this.path + this.dbPath1 + this.path + id2 + this.path + this.dbPath2 + this.path + id3);
    }

    getListItemProduct(id1: string, id2: string, id3: String): AngularFireList<ItemModel> {
        return this.db.list(this.dbPath + this.path + id1 + this.path + this.dbPath1 + this.path + id2 + this.path + this.dbPath2 + this.path + id3 + this.path + this.dbPath3);
    }

    //get infor of brand
    getInfoRoot(id: string): AngularFireObject<RootModel> {
        return this.db.object(this.dbPath + this.path + id);
    }

    //get all line of product of each brand
    getListLineProductOfBrand(id: string): AngularFireList<BrandModel> {
        return this.db.list(this.dbPath + this.path + id + this.path + this.dbPath1);
    }

    //get info of each line of product
    getInfoEachLineProduct(id1: string, id2: string): AngularFireObject<ProductModel> {
        return this.db.object(this.dbPath + this.path + id1 + this.path + this.dbPath1 + this.path + id2);
    }

    //get list all of product of each line of product
    getListProductOfLineProduct(id1: string, id2: string): AngularFireList<ItemModel> {
        return this.db.list(this.dbPath + this.path + id1 + this.path + this.dbPath1 + this.path + id2 + this.path + this.dbPath2);
    }

}
